import React, { useState, useEffect, useContext } from 'react';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';




function SearchFilter(props) {

  const { setFilter, type } = props;

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue('')
  }, [type]);

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      setFilter(prevFilter => ({ ...prevFilter, search: e.target.value }));
    }
  };


  const handleSearchChange = (e) => {
    setSearchValue(e.target.value)
    if (e.target.value == '') {
      setFilter(prevFilter => ({ ...prevFilter, search: e.target.value }));
    }
  };



  return (
    <div >

      <Form.Control type="search" size="sm" placeholder="Search..."
        onKeyDown={(e) => handleSearch(e)}
        onChange={(e) => handleSearchChange(e)}
        value={searchValue}
      >
      </Form.Control>

    </div>
  )
}

export default SearchFilter;
